export default "__VITE_ASSET__717118d2__"